import {
  isLineBreakElement,
  isStringElement,
} from '@packages/utilities/elementTypeUtils';
import {Expressions, matchExpression} from '@packages/systems/wfdl';
import {EElement, type ExpressionElement} from '@packages/systems/wfdl-ast';

/**
 * Concatenates all text content from descendants of an element.
 * Used for typographic elements to collect the whole text as a single translatable unit.
 */
export function collectTextFromDescendants(element: ExpressionElement): string {
  const collectText = Expressions.everything(
    (a: string) => (b: string) => a + b
  );

  return collectText(
    matchExpression({
      Element: (el) => {
        if (isLineBreakElement(el)) {
          return Expressions.resume('\n');
        }
        if (isStringElement(el)) {
          const text = Expressions.getText(Expressions.getElementData(el));
          return Expressions.resume(text || '');
        }
        return Expressions.resume('');
      },
      _: () => Expressions.resume(''),
    })
  )(EElement(element));
}
